/**
 * El avatar de una persona: sus iniciales y un color estable por nombre.
 *
 * Lo usan la pestaña «Seguimiento» (contactos) y el panel (las personas del
 * desplegable y de los repartos). El color es un indice del 1 al 6; cada hoja
 * de estilos lo traduce a sus tokens (seg-avatar--N, av--N).
 */

/** Las iniciales de un nombre («Ana Pérez Gil» -> «AG»). */
export function iniciales(nombre: string): string {
  const ps = nombre.trim().split(/\s+/).filter((p) => /\p{L}/u.test(p));
  return ((ps[0]?.[0] ?? '?') + (ps.length > 1 ? ps[ps.length - 1][0] : '')).toLocaleUpperCase('es');
}

/** El color del avatar, siempre el mismo para el mismo nombre (1 a 6). */
export function colorDe(nombre: string): number {
  let h = 0;
  for (const c of nombre.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()) h = (h * 31 + c.charCodeAt(0)) >>> 0;
  return (h % 6) + 1;
}
